<div class="customer-overview-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Customer Dashboard</span>

      <h1>
        Welcome <span>{{ userName }}</span>
      </h1>

      <p>
        Review your bookings, spending, reviews, favorite salons, and most used
        services from one personalized activity center.
      </p>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--light"
        [routerLink]="['../appointment']"
      >
        Book Appointment
      </button>

      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="refreshDashboard()"
      >
        Refresh
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <!-- <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Expense</span>
        <strong>{{ totalExpense | currency }}</strong>
        <p>Total amount spent across your visible bookings.</p>
      </div>

      <img [src]="assetUrl + 'icons/dollar-border.svg'" alt="" />
    </article> -->

    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Bookings</span>
        <strong>{{ totalBookingsCount }}</strong>
        <p>{{ completedBookings }} completed · {{ pendingBookings }} pending</p>
      </div>

      <img [src]="assetUrl + 'icons/calendar-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Your Reviews</span>
        <strong>{{ DashboardData.yourReviews || 0 }}</strong>
        <p>Reviews shared with salons you visited.</p>
      </div>

      <img [src]="assetUrl + 'icons/review-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Photos Shared</span>
        <strong>{{ DashboardData.yourPhotosShared || 0 }}</strong>
        <p>Photos added to your customer activity.</p>
      </div>

      <img [src]="assetUrl + 'icons/img-border.svg'" alt="" />
    </article>
  </section>

  <section class="metric-grid">
    <!-- <article class="metric-card">
      <span>Average Spend</span>
      <strong>{{ averageBookingSpend | currency }}</strong>
      <p>Average amount spent per booking.</p>
    </article> -->

    <article class="metric-card">
      <span>Favorite Salons</span>
      <strong>{{ dashboardCommonSalons.length }}</strong>
      <p>Frequently visited salon locations.</p>
    </article>

    <article class="metric-card">
      <span>Favorite Services</span>
      <strong>{{ dashboardCommonServices.length }}</strong>
      <p>Services used most often.</p>
    </article>

    <article class="metric-card metric-card--success">
      <span>Completed</span>
      <strong>{{ completedBookings }}</strong>
      <p>Appointments marked completed.</p>
    </article>

    <article class="metric-card metric-card--warning">
      <span>Upcoming / Pending</span>
      <strong>{{ pendingBookings }}</strong>
      <p>Bookings still upcoming or waiting.</p>
    </article>
  </section>

  <section class="bottom-grid">
    <article class="panel appointments-panel">
      <header class="panel-head">
        <div>
          <span class="panel-kicker">Appointments</span>
          <h2>Your Appointments</h2>
          <p>Recent and upcoming booking activity.</p>
        </div>

        <button
          type="button"
          class="overview-btn overview-btn--light"
          (click)="refreshAppointments()"
        >
          History
        </button>
      </header>

      <div class="appointment-list">
        @if (error && !isLoading) {
          <div class="empty-state">
            <p>{{ error }}</p>
            <button
              type="button"
              class="overview-btn overview-btn--dark"
              (click)="refreshDashboard()"
            >
              Try Again
            </button>
          </div>
        } @else if (dashboardAppointments.length === 0) {
          <div class="empty-state">
            <img [src]="assetUrl + 'icons/calendar.svg'" alt="" />
            <strong>No appointments found</strong>
            <p>You do not have any appointments scheduled yet.</p>
          </div>
        } @else {
          <article
            *ngFor="
              let appointment of dashboardAppointments;
              trackBy: trackByAppointmentId
            "
            class="appointment-card"
          >
            <div class="date-card">
              <span>{{ formateDate(appointment.start_time, "MMM") }}</span>
              <strong>{{ formateDate(appointment.start_time, "DD") }}</strong>
            </div>

            <div class="appointment-info">
              <div class="appointment-meta">
                <span>
                  {{ formateDate(appointment.start_time, "MMM D, YYYY") }} at
                  {{ formateTime(appointment.start_time) }}
                </span>

                <span
                  class="status-pill"
                  [ngClass]="statusClass(appointment.status)"
                >
                  {{ capitalizedStatus(appointment.status) }}
                </span>
              </div>

              <h3>{{ appointment.salon_name || "Salon appointment" }}</h3>

              <p>
                {{ appointment.salon_address || "No address" }},
                {{ appointment.salon_city || "No city" }}
              </p>
            </div>

            <div class="appointment-action">
              <strong>{{ appointment.total_price | currency }}</strong>

              <a
                [routerLink]="[
                  '../appointment/details',
                  appointment.appointment_id,
                ]"
                class="overview-btn overview-btn--dark"
              >
                Details
              </a>
            </div>
          </article>
        }
      </div>
    </article>

    <article class="panel business-health-panel">
      <header class="panel-head panel-head--stacked">
        <div>
          <span class="panel-kicker">Customer Snapshot</span>
          <h2>Your Activity</h2>
          <p>Quick indicators based on your booking history.</p>
        </div>
      </header>

      <div class="health-list">
        <div class="health-row">
          <div>
            <span>Completion Rate</span>
            <strong>{{ completionRate }}%</strong>
          </div>

          <div class="health-bar">
            <span [style.width.%]="completionRate"></span>
          </div>
        </div>

        <div class="health-row">
          <div>
            <span>Cancelled Rate</span>
            <strong>{{ cancellationRate }}%</strong>
          </div>

          <div class="health-bar health-bar--danger">
            <span [style.width.%]="cancellationRate"></span>
          </div>
        </div>

        <div class="health-row">
          <div>
            <span>Average Booking Spend</span>
            <strong>{{ averageBookingSpend | currency }}</strong>
          </div>
        </div>

        <div class="health-row">
          <div>
            <span>Photos Shared</span>
            <strong>{{ DashboardData.yourPhotosShared || 0 }}</strong>
          </div>
        </div>
      </div>
    </article>
  </section>

  <section class="main-grid">
    <article class="panel">
      <header class="panel-head">
        <div>
          <span class="panel-kicker">Visit Patterns</span>
          <h2>Most Common Salons</h2>
          <p>Salons you visit most frequently based on dashboard activity.</p>
        </div>

        <button
          type="button"
          class="overview-btn overview-btn--light"
          (click)="refreshSalonsChart()"
        >
          Refresh Chart
        </button>
      </header>

      <div class="chart-shell">
        <canvas #salonsChart></canvas>
      </div>
    </article>

    <article class="panel">
      <header class="panel-head">
        <div>
          <span class="panel-kicker">Service Activity</span>
          <h2>Most Common Services</h2>
          <p>Your most frequently booked services across salons.</p>
        </div>

        <button
          type="button"
          class="overview-btn overview-btn--light"
          (click)="refreshServicesChart()"
        >
          Refresh Chart
        </button>
      </header>

      <div class="chart-shell">
        <canvas #servicesChart></canvas>
      </div>
    </article>
  </section>

  <section class="bottom-grid">
    <article class="panel">
      <header class="panel-head">
        <div>
          <span class="panel-kicker">Favorite Salons</span>
          <h2>Frequently Visited Salons</h2>
          <p>Salons you have visited most often.</p>
        </div>
      </header>

      <div class="stack-list">
        @if (dashboardCommonSalons.length === 0) {
          <div class="empty-state">
            <strong>No salons found</strong>
            <p>You have not visited any salon yet.</p>
          </div>
        } @else {
          <article
            *ngFor="let salon of dashboardCommonSalons"
            class="stack-card"
          >
            <img
              [src]="salon.image || assetUrl + 'img/mock-salon1.png'"
              [alt]="salon.salon_name"
              (error)="onImageError($event)"
            />

            <div class="stack-info">
              <h3>{{ salon.salon_name || "Salon Name Not Available" }}</h3>

              <p>{{ salon.salon_city || "City not available" }}</p>

              <div class="stack-meta">
                <span>★ {{ salon.rating || "0.0" }}</span>
                <span>{{ salon.total_visits || 0 }} visits</span>
              </div>
            </div>

            <div class="stack-actions">
              <a
                *ngIf="salon.is_reviewed; else leaveReview"
                [routerLink]="['../salon/details', salon.salon_id]"
                class="overview-btn overview-btn--dark"
              >
                Details
              </a>

              <ng-template #leaveReview>
                <button
                  type="button"
                  class="overview-btn overview-btn--light"
                  (click)="AddReview(salon.salon_id)"
                >
                  Review
                </button>
              </ng-template>
            </div>
          </article>
        }
      </div>
    </article>

    <article class="panel">
      <header class="panel-head">
        <div>
          <span class="panel-kicker">Favorite Services</span>
          <h2>Frequently Used Services</h2>
          <p>Services you have booked most often.</p>
        </div>
      </header>

      <div class="stack-list">
        @if (dashboardCommonServices.length === 0) {
          <div class="empty-state">
            <strong>No services found</strong>
            <p>You have not used any service yet.</p>
          </div>
        } @else {
          <article
            *ngFor="let service of dashboardCommonServices"
            class="stack-card"
          >
            <img
              [src]="
                service.salon_image_url || assetUrl + 'img/mock-salon1.png'
              "
              [alt]="service.salon_name"
              (error)="onImageError($event)"
            />

            <div class="stack-info">
              <h3>
                {{ service.service_name || "Service Name Not Available" }}
              </h3>

              <p>{{ service.salon_name || "Salon Name Not Available" }}</p>

              <div class="stack-meta">
                <span>{{ service.price | currency }}</span>
                <span>{{ service.total_usage || 0 }} uses</span>
              </div>
            </div>
          </article>
        }
      </div>
    </article>
  </section>
</div>
